import { render, staticRenderFns } from "./work_quality_summary.vue?vue&type=template&id=3b95754d&scoped=true"
import script from "./work_quality_summary.vue?vue&type=script&lang=js"
export * from "./work_quality_summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b95754d",
  null
  
)

export default component.exports